module.exports = __webpack_public_path__ + "static/img/amore-disteady-thumb.57837f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/amore-disteady-thumb.jpg
// module id = 4HTU
// module chunks = 0